import Vue from 'vue'
import VueRouter from 'vue-router'

// 首页
import Index from '../views/index.vue'
// 用户信息认证 - 1
import step1 from '../views/ruleStep/step1.vue'
// 用户信息认证 - 2
import step2 from '../views/ruleStep/step2.vue'
// 用户信息认证 - 3
import step3 from '../views/ruleStep/step3.vue'
// 评估分数
import ScoreIndex from '../views/score/index.vue'
// 分数展示
import ScoreShow from '../views/score/show.vue'
// 审批系统
import Examine from '../views/examine/index.vue'
// 审批系统 - 失败
import Fail from '../views/result/fail.vue'
// 文字语音播放
import Audio from '../views/examine/audio.vue'
// 借款展示页面
import Show from '../views/examine/show.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/rulestep/setp1',
    name: 'step1',
    component: step1
  },
  {
    path: '/rulestep/setp2',
    name: 'step2',
    component: step2
  },
  {
    path: '/rulestep/setp3',
    name: 'step3',
    component: step3
  },
  {
    path: '/score/index',
    name: 'score',
    component: ScoreIndex
  },
  {
    path: '/score/show',
    name: 'score',
    component: ScoreShow
  },
  {
    path: '/examine/index',
    name: 'examine',
    component: Examine
  },
  {
    path: '/examine/fail',
    name: 'examine',
    component: Fail
  },
  {
    path: '/examine/audio',
    name: 'examine',
    component: Audio
  },
  {
    path: '/examine/show',
    name: 'show',
    component: Show
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
